/* eslint-disable jsx-a11y/no-autofocus */

import { Mutation } from '@apollo/client/react/components';
import ClearIcon from '@clearkit/icons/glyphs/CloseOrb';
import NewCollection from '@clearkit/icons/glyphs/FolderNew';
import {
  CKField,
  CKFieldLeftElement,
  CKFieldRightElement,
  CKTextField,
} from '@clearkit/react';

import mutation from './mutation.graphql';
import styles from './styles.style';

class AddCollectionButton extends React.Component {
  state = {
    showInput: false,
  };

  render() {
    const { classes, type } = this.props;
    const { showInput } = this.state;

    if (!showInput) {
      return (
        <div
          role="button"
          tabIndex="0"
          className={classes.newCollectionButton}
          onClick={() =>
            this.setState({
              showInput: !showInput,
            })
          }>
          <NewCollection className={classes.newCollectionIcon} />
          <span>New collection</span>
        </div>
      );
    }

    return (
      <>
        <Mutation
          mutation={mutation}
          refetchQueries={['SegmentsMenu']}
          onCompleted={() => {
            this.setState({ showInput: false });
          }}>
          {(mutation) => (
            <CKField className={classes.newCollectionInput}>
              <CKTextField
                onBlur={() => {
                  this.setState({ showInput: false });
                }}
                onKeyDown={(event) => {
                  if (event.key === 'Enter') {
                    const name = event.target.value.trim();
                    mutation({ variables: { input: { type, name } } });
                  } else if (event.key === 'Escape') {
                    this.setState({ showInput: false });
                  }
                }}
                autoFocus
                autoComplete="off"
                name="search"
                placeholder="Name this collection"
              />
              <CKFieldLeftElement>
                <NewCollection className={classes.newCollectionIcon} />
              </CKFieldLeftElement>
              <CKFieldRightElement isInteractive>
                <ClearIcon
                  onClick={() => {
                    this.setState({ showInput: false });
                  }}
                  width="16"
                  height="16"
                  className="text-white cursor-pointer opacity-40 hover:opacity-70 transition ease-linear duration-200"
                />
              </CKFieldRightElement>
            </CKField>
          )}
        </Mutation>
      </>
    );
  }
}

AddCollectionButton.propTypes = {
  classes: PropTypes.object,
  type: PropTypes.oneOf(['Company', 'Person']).isRequired,
};

export default withStyles(styles)(AddCollectionButton);
